export enum FormApplicant {
  'SOLO' = 'SOLO',
  'MULTI' = 'MULTI',
}
